/* ==========================================================================
   GM WISHLIST — device-local (localStorage) wishlist for Green Monkey.
   - Heart buttons anywhere with [data-gm-wish="<handle>"] toggle membership.
   - [data-gm-wish-count] elements reflect the count (hidden at 0).
   - [data-gm-wishlist-root] renders saved products (fetched via /products/x.js).
   No login or app required; the list lives in the visitor's browser.
   ========================================================================== */
(function () {
  var KEY = 'gm_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('gm:wishlist:change', { detail: list }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function toggle(item) {
    var handle = item && item.handle;
    if (!handle) return false;
    var list = read();
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].handle === handle) { idx = i; break; } }
    if (idx >= 0) list.splice(idx, 1);
    else { item.ts = Date.now(); list.unshift(item); }
    write(list);
    return has(handle);
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  function count() { return read().length; }

  window.GMWishlist = { read: read, has: has, toggle: toggle, remove: remove, count: count };

  /* ---- money formatting (uses shop format from the wishlist root) ---- */
  function formatMoney(cents, format) {
    var value = (cents / 100);
    var fmt = format || 'R{{amount}}';
    function withCommas(n, decimals) {
      var parts = (n).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, ' ').replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, ' ');
        default: return withCommas(value, 2);
      }
    });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function heartSvg() {
    return '<svg class="gm-wish__icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }

  /* ---- reflect state onto hearts + counts ---- */
  function syncHearts(root) {
    (root || document).querySelectorAll('[data-gm-wish]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-gm-wish'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btn.getAttribute(on ? 'data-label-on' : 'data-label-off');
      if (lbl) btn.setAttribute('aria-label', lbl);
    });
  }
  function syncCount() {
    var n = count();
    document.querySelectorAll('[data-gm-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---- heart click (delegated) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gm-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({
      handle: btn.getAttribute('data-gm-wish'),
      id: btn.getAttribute('data-gm-id'),
      title: btn.getAttribute('data-gm-title') || '',
      url: btn.getAttribute('data-gm-url') || '',
      price: parseInt(btn.getAttribute('data-gm-price'), 10) || 0,
      image: btn.getAttribute('data-gm-image') || '',
      available: btn.getAttribute('data-gm-available') !== 'false'
    });
    btn.classList.add('gm-wish--pop');
    setTimeout(function () { btn.classList.remove('gm-wish--pop'); }, 320);
  });

  /* ---- wishlist page renderer ---- */
  function renderWishlistPage() {
    var root = document.querySelector('[data-gm-wishlist-root]');
    if (!root) return;
    var grid = root.querySelector('[data-gm-wishlist-grid]');
    var empty = root.querySelector('[data-gm-wishlist-empty]');
    var moneyFormat = root.getAttribute('data-money-format') || 'R{{amount}}';
    var items = read();

    if (!items.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(function (p) {
      if (!p || !p.handle) return '';
      var img = p.image || '';
      var soldout = p.available === false;
      return '' +
        '<div class="gm-wl-card">' +
          '<button class="gm-wish is-active gm-wl-card__remove" data-gm-wish="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remove ' + esc(p.title) + ' from wishlist">' + heartSvg() + '</button>' +
          '<a class="gm-wl-card__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="gm-wl-card__body">' +
            '<a class="gm-wl-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="gm-wl-card__price">' + formatMoney(p.price, moneyFormat) + '</div>' +
            (soldout
              ? '<span class="gm-wl-card__oos">Out of stock</span>'
              : '<button type="button" class="gm-wl-card__atc" data-gm-wl-add data-variant="' + esc(p.id) + '">Add to Cart</button>') +
          '</div>' +
        '</div>';
    }).join('');
    syncHearts(grid);
  }

  /* ---- add to cart from the wishlist page ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gm-wl-add]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-variant');
    if (!id) return;
    b.disabled = true;
    var original = b.textContent;
    b.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () {
        b.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('gm:cart:added'));
        setTimeout(function () { b.textContent = original; b.disabled = false; }, 1400);
      })
      .catch(function () { b.textContent = original; b.disabled = false; });
  });

  /* ---- init + keep in sync across Dawn re-renders ---- */
  function init() { syncHearts(); syncCount(); renderWishlistPage(); }
  document.addEventListener('gm:wishlist:change', function () { syncHearts(); syncCount(); renderWishlistPage(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-mark hearts after AJAX product-grid / facet updates.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; syncHearts(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
